var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"main-scroll"},[_c('Navs'),_c('forget-passwd'),_c('Foots',{staticClass:"foots"})],1),_c('bottom-backtop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }